import ImageHoverEffectsContainer from "../../Componant/Gallery/ImageHoverEffects";

const ImageHoverEffects = () => {
  return (
    <div className="page-body">
      <ImageHoverEffectsContainer />
    </div>
  );
};

export default ImageHoverEffects;
